import * as React from 'react';
import instagramIcon from  "../../images/social/instagram.jsx";
import facebookIcon from  "../../images/social/facebook.jsx";
import youtubeIcon from   "../../images/social/youtube.jsx";
import logo from   "../../images/prime-logo.jsx";
// const instagramIcon = require( "../../images/social/instagram.jsx");
// const facebookIcon = require( "../../images/social/facebook.jsx");
// const youtubeIcon = require( "../../images/social/youtube.jsx");

// const logo = require("../../images/prime-logo.svg");

const currentYear = new Date().getFullYear();

export const Footer: React.FC<Props> = (props) => {
    return (
    <div className = "footer">
        <div className = "footer-contents">
            <div className = "left">
                {/* <ul>
                    <li>Contact Support</li>
                    <li>Submit Feedback</li> 
                </ul> */}
                <ul>
                    <li>© {currentYear} Prime Inc. All Rights Reserved. </li>
                    <div className = "icon-container">
                    <a className = "icon" href = "https://www.instagram.com/primetrucking/" target ="_blank"><div style={{height:'26px', width:"25px"}}>{instagramIcon()}</div></a>
                    <a className = "icon" href = "https://www.facebook.com/primepklc/" target = "_blank"> {facebookIcon()}</a>
                    <a className = "icon" href = "https://www.youtube.com/user/PRIMEINCTRUCKING" target = "_blank">{youtubeIcon()}</a>
                    </div>
                </ul>
            </div>
            <div className = "right">
                {logo()}
            </div>
        </div>
    </div>
    )
}

interface Props {

}